interface FqsConfig {
  Auth0ServiceUrl: string;
  UserManagementServiceUrl: string;
  AtomProxyServiceUrl: string;
  DashboardServiceUrl: string;
  DashboardApiKey: string;
  UIAuthAud: string;
  SuperUserRole: string;
  ApplicationAdminRole: string;
  Env: string;
  admin_app_url: string;
  client_app_url: string;
  // Add more keys if needed
}

const rawConfig = process.env.REACT_APP_FQS_CONFIG;

let parsed: FqsConfig = {
  Auth0ServiceUrl: "",
  UserManagementServiceUrl: "",
  AtomProxyServiceUrl: "",
  DashboardServiceUrl: "",
  DashboardApiKey: "",
  UIAuthAud: "",
  SuperUserRole: "",
  ApplicationAdminRole: "",
  Env: "",
  admin_app_url: "",
  client_app_url: "",
};

try {
  parsed = JSON.parse(rawConfig || "");
} catch (e) {
  console.error("[config] Failed to parse REACT_APP_FQS_CONFIG:", e);
}

const config = {
  domain: parsed.Auth0ServiceUrl,

  logger: {
    dev: console.log,
    sandbox: () => {},
    staging: () => {},
    prod: () => {},
  },
  usr_mgmt_endpoint: parsed.UserManagementServiceUrl,
  registry_api_endpoint: parsed.AtomProxyServiceUrl,
  dashboard_api_endpoint: parsed.DashboardServiceUrl,
  dashboard_api_key: parsed.DashboardApiKey,
  /**@todo remove all attributes except auth0_client_id once config api is implemented */

  client_mapping: parsed.UIAuthAud,
  superUserRole: parsed.SuperUserRole,
  applicationAdminRole: parsed.ApplicationAdminRole,
  csv_identifiers: ["hid"],
  user_env: parsed.Env,
  adminAppUrl: parsed.admin_app_url,
  clientAppUrl: `${parsed.client_app_url}/home`,
};
export default config;
